import type {UserImageAttachment} from '@Components/ai-prompt-box/components/ai-prompt-box-attachments/ai-prompt-box-attachments.types';
import {PromptAttachmentType} from '@Components/ai-prompt-box/components/ai-prompt-box-attachments/ai-prompt-box-attachments.types';
import type {FileUploadPipelineConfig, FileUploadPipelineState} from '@Components/ai-prompt-box/libraries/ai-prompt-box-file-upload.library';
import {handleFilesUpload, retryFileUpload} from '@Components/ai-prompt-box/libraries/ai-prompt-box-file-upload.library';

export interface ReferenceImageUploadState extends FileUploadPipelineState {
  getMaxAttachments: () => number;
}

export interface ReferenceImageUploadResponse {
  idaiImageAttachment: number;
  hashedFilename: string;
  extension: string;
}

const UPLOAD_REQUEST_TIMEOUT_MS = 7200000;

export const uploadAiReferenceAttachmentFile = async (file: File): Promise<ReferenceImageUploadResponse> => {
  const fd = new FormData();
  fd.append('Filedata', file);
  return (await window.PMW.writeLocal('ai/uploadReferenceAttachment', fd, 'json', {
    timeout: UPLOAD_REQUEST_TIMEOUT_MS,
    cache: false,
    processData: false,
    contentType: false,
  })) as ReferenceImageUploadResponse;
};

const buildReferenceImageUploadConfig = (state: ReferenceImageUploadState): FileUploadPipelineConfig<ReferenceImageUploadResponse> => {
  return {
    maxAttachments: state.getMaxAttachments(),
    attachmentType: PromptAttachmentType.REFERENCE_IMAGE,
    uploadFile: uploadAiReferenceAttachmentFile,
    resolveAttachment: (response: ReferenceImageUploadResponse): UserImageAttachment => ({
      type: PromptAttachmentType.REFERENCE_IMAGE,
      hashedFilename: response.hashedFilename,
      extension: response.extension,
      source: '',
    }),
  };
};

export const handleReferenceImageFilesUpload = (files: File[], state: ReferenceImageUploadState): void => {
  handleFilesUpload(files, state, buildReferenceImageUploadConfig(state));
};

export const retryReferenceImageUpload = (localId: string, state: ReferenceImageUploadState): void => {
  retryFileUpload(localId, state, buildReferenceImageUploadConfig(state));
};
